import * as React from "react";
import { classNames } from "src/utils/utils";

export type ButtonVariant =
  | "primary"
  | "outline"
  | "danger"
  | "link"
  | "themed-outline";

export type ButtonSize = "sm" | "md" | "lg" | "icon";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { children, className, variant = "primary", size = "md", ...props },
    ref
  ) => {
    const variantStyles: Record<ButtonVariant, string> = {
      primary: "bg-blue-600 text-white hover:bg-blue-700 shadow",
      outline: "border border-dark-blue bg-transparent hover:bg-gray-100",
      "themed-outline": "border border-[var(--dark-blue)]",
      danger: "bg-red-600 text-white hover:bg-red-700",
      link: "bg-transparent text-blue-600 hover:text-blue-800 underline-offset-4 hover:underline p-0 h-auto",
    };

    const sizeStyles: Record<ButtonSize, string> = {
      sm: "h-8 text-xs",
      md: "h-10",
      lg: "h-12 text-base",
      icon: "h-10 w-10 p-0",
    };

    const baseStyles =
      "inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";

    return (
      <button
        ref={ref}
        className={classNames(
          baseStyles,
          variantStyles[variant],
          sizeStyles[size],
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);
